import { useCallback, useEffect } from 'react';
import { useAppDispatch } from 'store/hooks';
import { setAuthenticated } from 'app/auth/slices';
import { LocalStorageService } from 'services';
import { Current } from 'app/userPreferences/types';
import { getRandomNumber } from 'utils/utils';
import { resetAppState } from 'store/actions';
import { authApi } from 'app/auth/api';

const { useLogoutMutation } = authApi;

const useLogout = () => {
  const dispatch = useAppDispatch();

  const [logoutUser] = useLogoutMutation();

  const clearAuthAndRedirectToLoginPage = useCallback(() => {
    logoutUser();

    const { conversionId } = LocalStorageService.get<Current>('current') || {};

    LocalStorageService.clear();

    LocalStorageService.set('current', {
      conversionId,
    });
    dispatch(resetAppState());
  }, [dispatch, logoutUser]);

  const logout = useCallback(() => {
    dispatch(setAuthenticated(false));
    localStorage.setItem('logout', `logout${getRandomNumber()}`);
    clearAuthAndRedirectToLoginPage();
  }, [dispatch, clearAuthAndRedirectToLoginPage]);

  useEffect(() => {
    window.addEventListener(
      'storage',
      (event) => {
        if (event.key === 'logout') {
          clearAuthAndRedirectToLoginPage();
        }
      },
      false,
    );
  }, [clearAuthAndRedirectToLoginPage]);

  return {
    logout,
  };
};

export default useLogout;
